import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import BioentityStorablesView from './BioentityStorablesView';
import StorageTabState from './StorageTabState';

class StorageTabView extends Backbone.View<StorageTabState> {
  render(): this {
    const model = this.model.get('model');
    renderToDOM(
      <BioentityStorablesView
        bioentityId={model.id}
        permissions={model.permissions()}
        tagSchema={model.tagSchema()}
      />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<StorageTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

StorageTabView.prototype.className = 'buffer-tab buffer-tab-reset buffer-tab--no-padding';

export default StorageTabView;
